Ext.define('SA.Ajax', {
    singleton: true,

    constructor() {
        this.enabled = true;
        this.observable = new Ext.util.Observable();
    },

    augmentCfg(cfg) {
        var httpMethod = cfg.data ? 'POST' : 'GET',
            url = `dispatch.php?${this.buildQueryString(cfg)}`;

        return {httpMethod, url, ...cfg};
    },

    buildQueryString({method = 'get', resource, format}) {
        var searchParams = new URLSearchParams();

        searchParams.append('v', method);
        searchParams.append('r', resource);

        if (format) {
            searchParams.append('f', format);
        }

        return searchParams.toString();
    },

    disable() {
        this.enabled = false;
    },

    onSendingRequest(method, scope) {
        this.observable.on('sendingrequest', method, scope);
    },

    async request(cfg) {
        var constructor = cfg.xhr ? SA.XhrRequest : SA.FetchRequest,
            request = Reflect.construct(constructor, [this.augmentCfg(cfg)]),
            {method: verb = 'get', resource} = cfg,
            span;

        if (!this.enabled) {
            return await request.unresolving();
        }

        this.observable.fireEvent('sendingrequest');

        span = elasticApm.startSpan(`${verb} ${resource}`);

        try {
            span?.addLabels({verb, resource});

            return await request.send();
        } finally {
            span?.end();
        }
    }
});
